import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { QueueVolumeData } from '@/hooks/useQueueMonitor';

interface QueueVolumeChartProps {
  data: QueueVolumeData[] | undefined;
  isLoading?: boolean;
}

/**
 * Componente que exibe gráfico de volume temporal da fila com AreaChart
 * Modelo visual igual ao CampaignQueueVolumeChart
 */
export function QueueVolumeChart({ data, isLoading }: QueueVolumeChartProps) {
  if (isLoading) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Volume de Processamento</CardTitle>
          <CardDescription>Mensagens processadas nas últimas 24 horas</CardDescription>
        </CardHeader>
        <CardContent>
          <Skeleton className="h-[250px] w-full" />
        </CardContent>
      </Card>
    );
  }

  if (!data || data.length === 0) {
    return (
      <Card>
        <CardHeader>
          <CardTitle>Volume de Processamento</CardTitle>
          <CardDescription>Mensagens processadas nas últimas 24 horas</CardDescription>
        </CardHeader>
        <CardContent>
          <div className="h-[250px] flex items-center justify-center text-muted-foreground">
            Sem dados de volume disponíveis
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle>Volume de Processamento por Hora</CardTitle>
        <CardDescription>Mensagens processadas nas últimas 24 horas</CardDescription>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={250}>
          <AreaChart data={data}>
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis 
              dataKey="hour" 
              className="text-xs"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
              interval="preserveStartEnd"
            />
            <YAxis 
              className="text-xs"
              tick={{ fill: 'hsl(var(--muted-foreground))' }}
            />
            <Tooltip 
              contentStyle={{
                backgroundColor: 'hsl(var(--card))',
                border: '1px solid hsl(var(--border))',
                borderRadius: '8px',
              }}
            />
            <Legend />
            <Area 
              type="monotone"
              dataKey="completed" 
              name="Completados" 
              stackId="1"
              stroke="hsl(142 76% 36%)"
              fill="hsl(142 76% 36%)"
              fillOpacity={0.6}
            />
            <Area 
              type="monotone"
              dataKey="failed" 
              name="Falhas" 
              stackId="2"
              stroke="hsl(var(--destructive))"
              fill="hsl(var(--destructive))"
              fillOpacity={0.6}
            />
          </AreaChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
